import React, { FunctionComponent } from 'react'
import { getPhoneNumber } from '@lib/PhoneNumber'
import Config from '@lib/Config'
import { PhoneNumberText } from './PhoneNumber.elements'

export interface PhoneNumberProps {
  mapping: PhoneMapping
  format: string
}

export const PhoneNumber: FunctionComponent<PhoneNumberProps> = ({
  mapping,
  format,
}: PhoneNumberProps) => (
  <PhoneNumberText>
    {getPhoneNumber(mapping, format)}
    {Config.usePhoneTTY && ' TTY 711'}
  </PhoneNumberText>
)
